import { Model } from '@/services/api/lib'

export default class Notification extends Model {
  resource () {
    return 'notifications/v1/templates'
  }

  updateMethod () {
    return 'PATCH'
  }
}
